import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export type CreditPackDto = {
  id: string;
  name: string;
  priceInCents: number;
  credits: number;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
};

export const GET_CREDIT_PACKS_QUERY_KEY = (organizationId: string) => [
  'creditPacks',
  'list',
  organizationId,
];

export const useListCreditPacks = (organizationId: string) => {
  const client = useApiClient();

  return useQuery({
    queryKey: GET_CREDIT_PACKS_QUERY_KEY(organizationId),
    queryFn: () =>
      client.fetchApi<CreditPackDto[], {}>({
        endpoint: `wallet/admin/credit-packs/${organizationId}`,
        method: 'GET',
      }),
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000,
  });
};
